export default __webpack_public_path__ + "static/media/landrover.f17fb00f.webp";